export enum EChoice {
  WithdrawByCart = 'withdraw_by_cart',
  Deposits = 'deposits'
}
